import React from 'react';
import { PropTypes } from 'prop-types';
import { compose, pure } from 'recompose';

const enhance = compose(pure);

const highlighted = (addressLine, searchText) => {
  let keywords = (searchText.replace(',', '').split(/\s+/gi) || []).map(
    (item) => item?.toLowerCase()
  );

  const commaSlittedAddress = addressLine.split(',');

  // We create an array with comma elements were there before, for future reconstruction
  let addressArrayWithCommas = [];
  commaSlittedAddress.forEach((value) => {
    addressArrayWithCommas.push(value);
    addressArrayWithCommas.push(',');
  });
  addressArrayWithCommas.pop(); // Remove last trailing comma

  // There could be space-separated strings inside an array element.
  // Perform additional splitting to end up with one word per array element
  let res = [];
  addressArrayWithCommas.forEach((item) => {
    let splittedItem = item.split(/\s+/gi);
    if (Array.isArray(splittedItem)) {
      splittedItem.forEach((subitem) => res.push(subitem));
    } else {
      res.push(splittedItem);
    }
  });

  // Transform array into a list of HTML + string elements.
  // Matches are bolded elements.
  // Given a processed item, if the next value in the array is a comma, do not append a space to the item
  return res.map((item, idx, arr) => {
    const isMatch = keywords.includes(item?.toLowerCase());
    const nextItemIsComma =
      idx + 1 <= arr.length ? arr[idx + 1] === ',' : false;
    const formattedItem = nextItemIsComma ? `${item}` : `${item} `;
    return isMatch ? (
      <span className="highlighted">{formattedItem}</span>
    ) : (
      formattedItem
    );
  });
};

const AddressSuggestionItem = ({
  activeRef,
  t,
  className,
  address,
  searchText,
  handleClick,
}) => (
  <button
    type="button"
    className={className}
    onClick={handleClick}
    ref={activeRef}
  >
    <div className="address">
      {highlighted(address.fullAddress, searchText)}
    </div>
  </button>
);

AddressSuggestionItem.propTypes = {
  activeRef: PropTypes.func,
  className: PropTypes.string,
  t: PropTypes.func,
  address: PropTypes.shape({}),
  handleClick: PropTypes.func,
};

AddressSuggestionItem.defaultProps = {
  className: '',
  t: (k) => k,
  address: {},
  handleClick: () => {},
  activeRef: () => {},
};

export default enhance(AddressSuggestionItem);
